// Rodzaj wiersza w `public.modules` — organ czy wtyczka integracyjna.
//
// Migracja 450 dołożyła kolumnę `module_kind`, bo jedna tabela trzyma odtąd dwa
// różne byty (patrz `docs/02-ARCHITECTURE/WTYCZKI_INTEGRACYJNE.md`):
//
//   * `organ`       — moduł z własną aplikacją, otwierany w powłoce pod
//                     `/admin/modules/<id>`;
//   * `integration` — wtyczka rozszerzająca system o rolę zewnętrznego systemu
//                     (Shopify, GoPOS). NIE MA własnego ekranu, więc kafel
//                     z przyciskiem „Otwórz moduł" prowadziłby donikąd.
//
// Warstwa czysta, bez I/O — żeby regułę dało się przetestować bez Reacta i bez
// bazy.

export type RodzajModulu = 'organ' | 'integration';

export const RODZAJ_DOMYSLNY: RodzajModulu = 'organ';

/**
 * Normalizuje wartość `module_kind` przeczytaną z bazy.
 *
 * Wartość nieznana (albo brak kolumny w `select`) daje `organ`, i to jest
 * wybór, nie zaniedbanie: powłoka pyta o moduły z kilkunastu miejsc, a nie
 * każde z nich wymienia tę kolumnę. Awaria „w stronę organu" zostawia rzeczy
 * tak, jak działały przed migracją 450 — wszystkie dziesięć modułów widocznych.
 * Awaria „w stronę wtyczki" schowałaby działający organ przed najemcą, który
 * za niego płaci, i wyglądałaby jak zniknięcie modułu.
 */
export function rodzajModulu(surowy: string | null | undefined): RodzajModulu {
  return surowy === 'integration' ? 'integration' : RODZAJ_DOMYSLNY;
}

/** Czy ten rodzaj ma własny ekran pod `/admin/modules/<id>`. */
export function maWlasnyEkran(rodzaj: RodzajModulu): boolean {
  return rodzaj === 'organ';
}

/** Skrót na surowej wartości z bazy — tyle wystarcza w miejscach renderowania. */
export function moduleMaWlasnyEkran(surowy: string | null | undefined): boolean {
  return maWlasnyEkran(rodzajModulu(surowy));
}
